export const SUMMARY_FLOW_OUTPUT_ID = 'outputObjectNode_1747166015458_0.8055';

export const SUMMARY_FLOW_VAR_INPUT_ID = 'varInputNode_1747428197481_0.4927';

export type FluxProductionMessageItem = {
  outputId?: string;
  text?: string;
};

export type FluxProductionDataShape = {
  message?: string | FluxProductionMessageItem[];
};

export function getFluxProductionErrorMessage(
  data: FluxProductionDataShape | undefined,
): string | null {
  if (data?.message && typeof data.message === 'string') {
    return data.message;
  }
  return null;
}

export function extractTextFromFluxProductionMessage(
  data: FluxProductionDataShape | undefined,
  fallback: string,
): string {
  if (!data?.message || !Array.isArray(data.message)) {
    return fallback;
  }
  if (data.message.length === 0) {
    return fallback;
  }
  const output = data.message.find(
    item => item.outputId === SUMMARY_FLOW_OUTPUT_ID,
  );
  if (output?.text) {
    return output.text;
  }
  const first = data.message[0];
  return first?.text ?? fallback;
}
